import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/SeeAllArticlesGrid.css";

const SeeAllArticlesGrid = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const articles = location.state?.articles || [];

  // Track screen size for conditional rendering
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleVideoClick = (videoUrl) => {
    let videoId = videoUrl.includes("watch?v=")
      ? videoUrl.split("watch?v=")[1].split("&")[0]
      : null;

    const urlParams = new URLSearchParams(
      videoUrl.substring(videoUrl.indexOf("?") + 1)
    );
    const playlistId = urlParams.get("list");

    if (playlistId && videoId) {
      navigate(`/watch/${videoId}?list=${playlistId}`);
    } else if (videoId) {
      navigate(`/watch/${videoId}`);
    } else {
      console.warn("Could not parse videoId from URL:", videoUrl);
    }
  };

  // ================
  // Mobile Layout
  // ================
  const renderMobile = () => (
    <div className="see-all-container">
      <div className="header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <img
            src="/static/images/arrowLeftSymbol.png"
            alt="Back"
            className="arrow-left-symbol"
          />
        </button>
        <h1 className="articles-section-title">Title Section 2</h1>
      </div>

      <div className="see-all-articles-list">
        {articles.map((video) => (
          <div
            key={video.id}
            className="see-all-articles-item"
            onClick={() => handleVideoClick(video.id)}
          >
            <img
              src={video.thumbnail}
              alt={video.title}
              className="articles-thumbnail"
            />
            <h3 className="articles-title">{video.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );

  // ================
  // Desktop Layout
  // ================
  const renderDesktop = () => (
    <div className="see-all-container-desktop">
      <div className="header-desktop">
        <button className="back-button-desktop" onClick={() => navigate(-1)}>
          <img
            src="/static/images/arrowLeftSymbol.png"
            alt="Back"
            className="arrow-left-symbol"
          />
        </button>
        <h1 className="articles-section-title-desktop">Title Section 2</h1>
      </div>

      <div className="see-all-articles-list-desktop">
        {articles.map((video) => (
          <div
            key={video.id}
            className="see-all-articles-item-desktop"
            onClick={() => handleVideoClick(video.id)}
          >
            <img
              src={video.thumbnail}
              alt={video.title}
              className="articles-thumbnail-desktop"
            />
            <h3 className="articles-title-desktop">{video.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );

  return isMobile ? renderMobile() : renderDesktop();
};

export default SeeAllArticlesGrid;
